module.exports = __webpack_public_path__ + "media/flags/ar-10ea98e2.svg";